"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateVolatilityFuturesTable = void 0;
const calculationsCore_1 = require("../calculationsCore");
const pnlCalculations_1 = require("../pnlCalculations");
const types_1 = require("../types");
const volFutureDvolMovePnl = (amount, volRange, daysToExpiry, vegaPower, price) => {
    return amount * volRange * price * Math.pow((30 / daysToExpiry), vegaPower);
};
const calculateVolatilityFuturesTable = (positions, tickers, pmParams, calculationTimestamp) => {
    const dvolPositions = positions.filter((p) => (0, pnlCalculations_1.getInstrumentType)(p.instrument) === types_1.PositionType.VolatilityFuture);
    const table = [];
    let totalUp = 0;
    let totalDown = 0;
    for (const position of dvolPositions) {
        const expiry = (0, calculationsCore_1.getExpiryTimestampFromInstrumentString)(position.instrument);
        const daysToExpiry = (0, calculationsCore_1.getDifferenceInDaysBetweenDates)(calculationTimestamp, expiry);
        const price = tickers[position.instrument].underlyingPrice;
        const tracking = (0, calculationsCore_1.offsetTimestampByDays)(expiry, 30);
        const vegaPower = daysToExpiry > 30
            ? pmParams.general.longTermVegaPower
            : pmParams.general.shortTermVegaPower;
        const down = volFutureDvolMovePnl(position.amountCurrency, pmParams.general.volRangeDown, daysToExpiry, vegaPower, price);
        const up = volFutureDvolMovePnl(position.amountCurrency, pmParams.general.volRangeUp, daysToExpiry, vegaPower, price);
        totalDown += down;
        totalUp += up;
        const row = {
            amount: position.amountCurrency,
            daysToExpiry,
            expiry,
            instrument: position.instrument,
            price,
            tracking,
            up,
            down,
        };
        table.push(row);
    }
    return { table, totalDown, totalUp };
};
exports.calculateVolatilityFuturesTable = calculateVolatilityFuturesTable;
